import React from 'react';
import { Card } from '../components/ui/display/Card.jsx';
import { pickLocalized, tFor } from '../i18n/i18n.js';
import { formatBaht } from '../lib/price.js';

// Service picker. Renders a vertical stack of service cards filtered by
// category (pills at the top if there is more than one category). Click
// calls `onSelect(serviceId)` and we transition to the staff picker.

export function StepService({ services, categories, category, onCategoryChange, onSelect, locale }) {
  const t = tFor(locale);
  const visibleServices = category
    ? services.filter((s) => s.categoryId === category)
    : services;

  const categoriesWithServices = categories.filter((c) =>
    services.some((s) => s.categoryId === c.id)
  );

  if (services.length === 0) {
    return <div className="sp-empty">{t('service.empty')}</div>;
  }

  return (
    <Card title={t('service.heading')}>
      {categoriesWithServices.length > 1 && (
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8, marginBottom: 16 }}>
          <CategoryPill
            active={category == null}
            onClick={() => onCategoryChange(null)}
            label="All"
          />
          {categoriesWithServices.map((c) => (
            <CategoryPill
              key={c.id}
              active={category === c.id}
              onClick={() => onCategoryChange(c.id)}
              label={pickLocalized(c.translations, locale)}
            />
          ))}
        </div>
      )}

      <div className="sp-services">
        {visibleServices.map((service) => {
          const name = pickLocalized(service.translations, locale);
          const desc = pickLocalized(service.descriptionTranslations, locale);
          return (
            <button
              key={service.id}
              type="button"
              className="sp-service"
              onClick={() => onSelect(service.id)}
            >
              <div className="sp-service__body">
                <div className="sp-service__title">{name}</div>
                {desc && <div className="sp-service__desc">{desc}</div>}
                {service.durationMinutes && (
                  <div className="sp-service__duration">
                    {t('service.duration').replace('{n}', String(service.durationMinutes))}
                  </div>
                )}
              </div>
              <div className="sp-service__price">{formatBaht(service.price)}</div>
            </button>
          );
        })}
      </div>
    </Card>
  );
}

function CategoryPill({ active, onClick, label }) {
  return (
    <button
      type="button"
      onClick={onClick}
      style={{
        background: active ? 'var(--brand-tint)' : 'var(--surface)',
        border: '1px solid ' + (active ? 'var(--brand)' : 'var(--border-strong)'),
        color: active ? 'var(--text-brand)' : 'var(--text-body)',
        borderRadius: 'var(--radius-pill)',
        padding: '4px 12px',
        fontSize: 'var(--text-sm)',
        fontWeight: 600,
        cursor: 'pointer',
        fontFamily: 'inherit',
      }}
    >
      {label}
    </button>
  );
}
